module.exports = __webpack_public_path__ + "img/8.95eb4f11.jpg";